module.exports = __webpack_public_path__ + "media/images/lp/lp04-cabc1f3495b0e4d5adb16c3d042af03a.webp";